import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'SpamBlocker',
  quiz = 'SpamBlockerQuiz',
  emailSpam = 'SpamBlockerEmailSpam',
  protectPersonalData = 'SpamBlockerProtectPersonalData',
  samePassword = 'SpamBlockersSamePassword',
  protectInfo = 'SpamBlockersProtectInfo',
  help = 'SpamBlockersHelp',
  reviews = 'SpamBlockersReviews',
  checkData = 'SpamBlockersCheckData',
  onlineThreats = 'SpamBlockersOnlineThreats',
  loader = 'SpamBlockerLoader',
  result = 'SpamBlockerResult',
  preparing = 'SpamBlockerPreparing',
  auth = 'SpamBlockerAuth',
  payment = 'SpamBlockerPayment',
}

function preloadModule(name: MODULE_ROUTE) {
  const parentRoute = routes.find((layoutRoute) =>
    layoutRoute.children?.find((route) => route.name === name),
  );

  const route = parentRoute?.children?.find((route) => route.name === name);

  if (route && 'component' in route && typeof route.component === 'function') {
    (route.component as unknown as () => void)();
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/spam-blocker/',
    component: () => import('@/modules/spam-blocker/layout/LayoutPage.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () =>
          import('@/modules/spam-blocker/pages/index/PageSafeOnline.vue'),
        meta: {
          abtestGroup: 1,
        },
        beforeEnter() {
          setTimeout(() => {
            Object.values(MODULE_ROUTE)
              .filter((moduleName) => moduleName !== MODULE_ROUTE.index)
              .forEach((moduleName) =>
                preloadModule(moduleName as MODULE_ROUTE),
              );
          }, 1000);
        },
      },
      {
        path: 'email-spam/',
        name: MODULE_ROUTE.emailSpam,
        component: () =>
          import('@/modules/spam-blocker/pages/email-spam/PageSafeOnlineEmailSpam.vue'),
      },
      {
        path: 'protect-personal-data/',
        name: MODULE_ROUTE.protectPersonalData,
        component: () =>
          import('@/modules/spam-blocker/pages/protect-personal-data/PageSafeOnlineProtectPersonalData.vue'),
      },
      {
        path: 'same-password/',
        name: MODULE_ROUTE.samePassword,
        component: () =>
          import('@/modules/spam-blocker/pages/same-password/PageSafeOnlineSamePassword.vue'),
      },
      {
        path: 'protect-info/',
        name: MODULE_ROUTE.protectInfo,
        component: () =>
          import('@/modules/spam-blocker/pages/protect-info/PageSafeOnlineProtectInfo.vue'),
      },
      {
        path: 'help/',
        name: MODULE_ROUTE.help,
        component: () =>
          import('@/modules/spam-blocker/pages/help/PageSafeOnlineHelp.vue'),
      },
      {
        path: 'online-threats/',
        name: MODULE_ROUTE.onlineThreats,
        component: () =>
          import('@/modules/spam-blocker/pages/online-threats/PageSafeOnlineOnlineThreats.vue'),
      },
      {
        path: 'reviews/',
        name: MODULE_ROUTE.reviews,
        component: () =>
          import('@/modules/spam-blocker/pages/reviews/PageSafeOnlineReviews.vue'),
      },
      {
        path: 'check-data/',
        name: MODULE_ROUTE.checkData,
        component: () =>
          import('@/modules/spam-blocker/pages/check-data/PageSafeOnlineCheckData.vue'),
      },
      {
        path: 'quiz/',
        name: MODULE_ROUTE.quiz,
        component: () =>
          import('@/modules/spam-blocker/pages/quiz/PageQuiz.vue'),
      },
      {
        path: 'loader/',
        name: MODULE_ROUTE.loader,
        component: () =>
          import('@/modules/spam-blocker/pages/loader/PageLoader.vue'),
      },
      {
        path: 'result/',
        name: MODULE_ROUTE.result,
        component: () =>
          import('@/modules/spam-blocker/pages/result/PageResult.vue'),
      },
      {
        path: 'preparing/',
        name: MODULE_ROUTE.preparing,
        component: () =>
          import('@/modules/spam-blocker/pages/preparing/PagePreparing.vue'),
      },
      {
        path: 'auth/',
        name: MODULE_ROUTE.auth,
        component: () =>
          import('@/modules/spam-blocker/pages/auth/PageAuth.vue'),
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/spam-blocker/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
